import * as Config from '../../../config';
import React, { useEffect } from 'react';
import { connect, useSelector } from "react-redux";
import PropTypes from 'prop-types';

import BlockSession from './BlockSession';

function ConnectedListSessions({ rooms, height }) {
  const socket = useSelector(state => state.socketPM);
  const refresh = useSelector(state => state.refreshPublicSessions);
  rooms = rooms.filter( r => r.a.length > 0 )
  const total = rooms.length;
  rooms.sort((a, b) => {
    if (a.a.length < b.a.length) { return -1 }
    if (a.a.length > b.a.length) { return  1 }
    return 0;
  })

  // Refresh each time the tab is clicked
  useEffect(() => {
    if (socket && refresh) {
      socket.emit("get public rooms", { from: Config.ACRONYME });
    }
  }, [socket, refresh])

  return (
    <div className={`flexColumn`} style={{ gap: 16 }}>
      <span className={`grey-2 type-medium fz15`} style={{padding: '0px'}}>Live Sets</span>
      { total > 0
        ? (
          <div className={'flexColumn space-between'} style={{ maxHeight: height - 110, gap: 16, overflow: `auto` }}>
            { rooms.map( room => <BlockSession key={`BS-${room.id}`} room={room} /> ) }
          </div>
        )
        : (
          <div className={'flexCenter'}>
            <span className={'type-secondary type-small fz11'}>No sets are currently live.</span>
          </div>
        )
      }
    </div>
  )
}

ConnectedListSessions.propTypes = {
  rooms: PropTypes.array
}

const ListSessions = connect(
  state => ({
    rooms: state.roomsPM
  })
)(ConnectedListSessions);

export default ListSessions;
